import FormController from './form_controller';
import Events from '../classes/Events';
import Utility from '../classes/Utility';
import axios from 'axios';

class PaymentForm extends FormController {
  static targets = [
    'country',
    'zipcode',
    'cardholderName',
    'creditCardNumber',
    'expiryDate',
    'cvc',
    'errorMessage'
  ]

  static values = { 
    noRedirect: String
  }

  targetNames() {
    return PaymentForm.targets;
  }

  async createPayment(e) {
    this.errorMessageTarget.classList.remove('t-hidden');
    const stripeFields = {};
    const stripeKey = this.data.get('publishable-key');
    window.Stripe.setPublishableKey(stripeKey);
    e.preventDefault();
    stripeFields['address_country'] = this.countryTarget.value;
    stripeFields['address_zip'] = this.zipcodeTarget.value;
    stripeFields['exp_year'] = this.expiryDateTarget.value.split('/')[1];
    stripeFields['exp_month'] = this.expiryDateTarget.value.split('/')[0];
    stripeFields['cvc'] = this.cvcTarget.value;
    stripeFields['number'] = this.creditCardNumberTarget.value;
    stripeFields['name'] = this.cardholderNameTarget.value;
    Stripe.card.createToken(stripeFields, this.stripeResponseHandler);
  }

  stripeResponseHandler = (status, response) => {
    if (response.error) {
      axios({
        method: 'post',
        url: '/api/error_log/',
        dataType: 'json',
        data: {
          property: window.websiteProperty,
          type: 'stripe',
          error_code: response.error.code,
          data: response.error,
          related_id: Utility.getCookie('st')
        }
      }).then(() => {
        const erroringField = this.element.querySelector(`[name="${response.error.param}"]`);
        erroringField.dataset['error'] = response.error.message;
        erroringField.dispatchEvent(Events.validationEvent);
        this.element.dispatchEvent(Events.errorEvent)
        EventManager.emit('force-reset-coupon', {});
      }).catch(() => {
        // Something is wrong when saving payment to db
      })
    } else {
      axios({
        method: 'post',
        url: '/users/payment/',
        dataType: 'json',
        data: {
          stripe_token: response.id,
          coupon: Utility.getCookie('coupon_code') != 'unknown' ? Utility.getCookie('coupon_code') : null,
          cardholder_name: this.cardholderNameTarget.value
        }
      }).then(() => {
        // Successfully registered Payment card to stripe
        this.element.setAttribute('data-payment-state', 'Premium');
        this.element.dispatchEvent(Events.submittedEvent);
      }).catch(() => {
        this.element.dispatchEvent(Events.errorEvent)
        EventManager.emit('force-reset-coupon', {});
        // Something is wrong when saving payment to db
        // set a generic error message
      })
    }
  }

  showError() {
    this.errorMessageTarget.textContent = "Looks like we're missing some information.";
    this.errorMessageTarget.classList.remove('t-hidden');
  }

  hideError() {
    this.errorMessageTarget.classList.add('t-hidden');
  }

  autofill(e) {
    const { target } = e;
    const { value } = target;
    if (value && value.length === 2 && !value.endsWith('/')) {
      e.target.value = value + '/';
    } else if (value && value.length === 3 && !value.endsWith('/')) {
      e.target.value = value.substring(0, 2);
    }
  }

  initialize() {
    Utility.insertJS('https://js.stripe.com/v1/', false, true);
    if(!this.hasNoRedirectValue) window.history.replaceState({}, 'Sign up for Dividend.com Premium', '/payment/');
    EventManager.emit('payment-form-loaded', {});
  }

}

export default PaymentForm;
